import { render, staticRenderFns } from "./AssignedCards.vue?vue&type=template&id=8e47d0ec&"
import script from "./AssignedCards.vue?vue&type=script&lang=js&"
export * from "./AssignedCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports